'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/supports/:supportId', null, {
            get: {method: 'GET'},
            create: {url: 'api/supports', method: 'POST'},
            update: {url: 'api/supports/:supportId', method: 'PUT'},
            remove: {method: 'DELETE'},
            delete: {url: 'api/supports/:supportId', method: 'DELETE'},
        });
    }];